/* ============================================================
   Vantor — app-236 chrome behaviour (patched FROM app-189)
   Minimal: open/close the drawer, trap focus, Esc + overlay
   click to close, scroll lock. No framework, no build step.

   Scoped per `[data-chrome-id]` wrapper so a single page can host
   more than one independent header+drawer instance (used by the
   chrome-390.html / chrome-768.html closed+open demo frames).
   A normal page template has exactly one wrapper, id "site".
   ============================================================ */
(function () {
  // QA convenience for chrome-390.html / chrome-768.html: those pages embed
  // the real page templates in <iframe>s (so @media breakpoints evaluate
  // against the iframe's own true width, not the parent window). Appending
  // ?menu=open to any page's URL opens the drawer on load, which is how the
  // "open" iframe in each demo gets its state — no markup is duplicated.
  var forceOpen = /(?:^|[?&])menu=open(?:&|$)/.test(location.search);

  document.querySelectorAll('[data-chrome-id]').forEach(function (scope) {
    var menuBtn  = scope.querySelector('[data-menu-toggle]');
    var closeBtn = scope.querySelector('[data-menu-close]');
    var drawer   = scope.querySelector('[data-drawer]');
    var overlay  = scope.querySelector('[data-drawer-overlay]');
    if (!menuBtn || !drawer || !overlay) return;

    var lastFocused = null;

    function focusableEls() {
      return drawer.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])');
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('drawer-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      drawer.removeAttribute('aria-hidden');
      var f = focusableEls();
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusableEls();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    menuBtn.addEventListener('click', function () {
      var open = menuBtn.getAttribute('aria-expanded') === 'true';
      open ? closeDrawer() : openDrawer();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    if (forceOpen) openDrawer();

    // SWITCH 1280: the drawer does not exist at desktop width. If it was open
    // while the window crossed the breakpoint, close it so scroll lock and
    // aria-expanded don't get stranded behind a hidden sheet.
    var desktop = window.matchMedia('(min-width: 1280px)');
    function onSwitch(e) { if (e.matches && menuBtn.getAttribute('aria-expanded') === 'true') closeDrawer(); }
    if (desktop.addEventListener) desktop.addEventListener('change', onSwitch);
  });

  /* ---------- Catalog hover submenu (≥1280) ----------
     Hover and :focus-within are pure CSS. JS only adds what CSS can't:
     aria-expanded, Esc to dismiss, and tap-to-open on touch laptops/tablets
     where there is no hover (first tap opens, second tap follows the link). */
  document.querySelectorAll('[data-submenu]').forEach(function (item) {
    var trigger = item.querySelector('[data-submenu-trigger]');
    if (!trigger) return;
    function setOpen(open) {
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    item.addEventListener('mouseenter', function () { trigger.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { setOpen(false); });
    item.addEventListener('focusin',  function () { trigger.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) setOpen(false); });
    item.addEventListener('keydown',  function (e) { if (e.key === 'Escape') { setOpen(false); trigger.blur(); } });
    trigger.addEventListener('click', function (e) {
      var noHover = window.matchMedia('(hover: none)').matches;
      if (noHover && !item.classList.contains('is-open')) { e.preventDefault(); setOpen(true); }
    });
    if (/(?:^|[?&])submenu=open(?:&|$)/.test(location.search)) setOpen(true);
  });

  /* ---------- cart badge: single writer Vantor.setCartCount (Shopify cart.item_count) ---------- */
  if (window.Vantor && typeof window.Vantor.setCartCount === 'function') {
    window.Vantor.setCartCount(window.Vantor.state ? window.Vantor.state.cart : 0);
  }
})();
